export const USERS_PLAN_USAGE_PAGE = {
  ACCOUNT_USAGE_TITLE: { key: 'ACCOUNT_USAGE_TITLE', value: 'Account usage' },
  ACCOUNT_USAGE_DESCRIPTION: {
    key: 'ACCOUNT_USAGE_DESCRIPTION',
    value: 'Learn about your current month account usage and stats',
  },
  EACH_PLAN_TOTAL_QUOTA_TEXT: { key: 'EACH_PLAN_TOTAL_QUOTA_TEXT', value: 'Quota' },
  STORAGE_FULL_WARNING_MESSAGE: {
    key: 'STORAGE_FULL_WARNING_MESSAGE',
    value: 'Used up all of the storage, Please upgrade the plan to design more',
  },
  STORAGE_FULL_TOOLTIP: {
    key: 'STORAGE_FULL_TOOLTIP',
    value: 'Used up all of the storage',
  },
  CREATED_MAXIMUM_TEAMS_TOOLTIP: {
    key: 'CREATED_MAXIMUM_TEAMS_TOOLTIP',
    value: 'Created maximum teams',
  },
  CREATED_MAXIMUM_USERS_TOOLTIP: {
    key: 'CREATED_MAXIMUM_USERS_TOOLTIP',
    value: 'Created maximum users',
  },
  CREATED_MAXIMUM_SUPPORTED_LANGUAGE_TOOLTIP: {
    key: 'CREATED_MAXIMUM_SUPPORTED_LANGUAGE_TOOLTIP',
    value: 'Used up available languages',
  },
  CREATED_MAXIMUM_TEXT_GENERATION_TOOLTIP: {
    key: 'CREATED_MAXIMUM_TEXT_GENERATION_TOOLTIP',
    value: 'Text generation limit has been reached',
  },
  CREATED_MAXIMUM_TRANSLATION_TOOLTIP: {
    key: 'CREATED_MAXIMUM_TRANSLATION_TOOLTIP',
    value: 'Translation limit has been reached ',
  },
  DOCUMENTS_LABEL: {
    key: 'DOCUMENTS_LABEL',
    value: 'Documents'
  },
  TEMPLATE_CREATION_TOOLTIP: {
    key: 'TEMPLATE_CREATION_TOOLTIP',
    value: 'Template creation limit has been reached'
  },
  PLAN_USED_COUNT_TEXT: { key: 'PLAN_USED_COUNT_TEXT', value: 'Used' },
  NEXT_RENEWAL_DATE_TEXT: { key: 'NEXT_RENEWAL_DATE_TEXT', value: 'Next Renewal' },
  UPGRADE_PLAN_BUTTON: { key: 'UPGRADE_PLAN_BUTTON', value: 'Upgrade Plan' },
  REDIRECTING_TO_UPGRADE_TEXT: { key: 'REDIRECTING_TO_UPGRADE_TEXT', value: 'Redirecting' },
  DOCUMENT_GENERATION_SECTION_TITLE: {
    key: 'DOCUMENT_GENERATION_SECTION_TITLE',
    value: 'Document Generation'
  },
  EMAIL_DELIVERY_TITLE: {
    key: 'EMAIL_DELIVERY_TITLE',
    value: 'Email Delivery'
  },
  DOCUMENT_OR_EMAIL_CREATION_LABEL: {
    key: 'DOCUMENT_OR_EMAIL_CREATION_LABEL',
    value: 'Document / Email Creation'
  },
  TEMPLATES_LABEL: { key: 'TEMPLATES_LABEL', value: 'Templates' },
  UPGRADE_PLAN_TOOLTIP: {
    key: 'UPGRADE_PLAN_TOOLTIP',
    value: 'Contact your admin to upgrade this account',
  },
  TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT: {
    key: 'TOTAL_DOCUMENT_CAN_BE_GENERATED_TEXT',
    value: 'Quota',
  },
  REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT: {
    key: 'REMAINING_DOCUMENT_CAN_BE_GENERATED_TEXT',
    value: 'Remaining',
  },
  PLAN_USAGE_RENEWAL_KEY_NOTE_TEXT: {
    key: 'PLAN_USAGE_RENEWAL_KEY_NOTE_TEXT',
    value:
      'NOTE : Users, teams, Languages and storage quotas are managed at the account level, while text generation, the number of pages for documents, and translation quotas are renewed on a monthly basis.',
  },
  USERS_USED_DETAILS_TEXT: { key: 'USERS_USED_DETAILS_TEXT', value: 'Users' },
  TEAMS_USED_DETAILS_TEXT: { key: 'TEAMS_USED_DETAILS_TEXT', value: 'Teams' },
  STORAGE_USED_DETAILS_TEXT: { key: 'STORAGE_USED_DETAILS_TEXT', value: 'Storage' },
  LANGUAGES_USED_DETAILS_TEXT: { key: 'LANGUAGES_USED_DETAILS_TEXT', value: 'Supported Language' },
  DOCUMENT_CREATION_COUNT_TEXT: {
    key: 'DOCUMENT_CREATION_COUNT_TEXT',
    value: 'Document Creation'
  },
  TEXT_GENERATION_USED_COUNT_TEXT: {
    key: 'TEXT_GENERATION_USED_COUNT_TEXT',
    value: 'Text Generation',
  },
  TRANSLATION_USED_COUNT_TEXT: { key: 'TRANSLATION_USED_COUNT_TEXT', value: 'Translation' },
  BRANDING_INFORMATION_TEXT: { key: 'BRANDING_INFORMATION_TEXT', value: 'Doc Studio Branding' },
  SUPPORT_INFORMATION_TEXT: { key: 'SUPPORT_INFORMATION_TEXT', value: 'Support' },
  BRANDING_DISPLAY_TEXT: { key: 'BRANDING_DISPLAY_TEXT', value: 'Branding Displayed' },
  BRANDING_REMOVED_TEXT: { key: 'BRANDING_REMOVED_TEXT', value: 'Branding Removed' },
  SUPPORT_NOT_AVAILABLE_TEXT: { key: 'SUPPORT_NOT_AVAILABLE_TEXT', value: 'Not available' },
  SUPPORT_AVAILABLE_TEXT: { key: 'SUPPORT_AVAILABLE_TEXT', value: '24 * 7 Email Support' },
  SOMETHING_WRONG_ERROR_MESSAGE: { key: 'SOMETHING_WRONG_ERROR_MESSAGE', value: 'Something went wrong. Please try again later' },
  TRANSACTIONS_LABEL: { key: 'TRANSACTIONS_LABEL', value: 'Transactions' },
  PAGES_LABEL: { key: 'PAGES_LABEL', value: 'Pages' },
  EMAILS_LABEL: { key: 'EMAILS_LABEL', value: 'Emails' },
};
